// Tag constants for RTK Query cache invalidation.
// IMPORTANT: providesTags and invalidatesTags MUST use the same constant.
// RTK Query matches tags by exact string value, so a mismatch between
// providesTags: ["INVALIDATE_SALARIES"] and invalidatesTags: ["SALARIES"]
// means the cache is NEVER invalidated and stale data is shown.

export const INVALIDATE_USERS = "Users";
export const INVALIDATE_DOSSIER = "Dossiers";
export const INVALIDATE_CLIENT = "Clients";
export const INVALIDATE_FOURNISSEURS = "Fournisseurs";
export const INVALIDATE_PRODUITS = "Produits";

// Tags added during audit (previously undeclared or mismatched)
export const INVALIDATE_SALARIES = "Salaries";
export const INVALIDATE_OPERATEURS = "Operateurs";
export const INVALIDATE_COMPTE_PAIEMENT = "ComptePaiement";
export const INVALIDATE_COLLABORATEUR = "Collaborateur";
export const INVALIDATE_FACTURE = "Facture";
export const INVALIDATE_FACTURES = "Factures";
export const INVALIDATE_CODE_JOURNAL = "CodeJournal";
export const INVALIDATE_ECRITURE = "EcritureComptable";
export const INVALIDATE_LIVRE_JOURNAL = "LivreJournal";
export const INVALIDATE_OCR = "OCR";
export const INVALIDATE_ROLES = "Roles";
export const INVALIDATE_PLAN_COMPTABLE = "PlanComptable";
export const INVALIDATE_DETTES = "Dettes";
export const INVALIDATE_CREANCES = "Creances";
export const INVALIDATE_VENTES = "Ventes";
export const INVALIDATE_DEPENSES = "Depenses";
export const INVALIDATE_TRANSACTIONS = "Transactions";
export const INVALIDATE_PERMISSIONS = "Permissions";
export const INVALIDATE_BILAN_COMPTABLE = "BilanComptable";
export const INVALIDATE_TIERS = "Tiers";
export const INVALIDATE_CURRENT_USER = "CurrentUser";
export const INVALIDATE_PAIEMENT_CREANCES = "PaiementCreances";
export const INVALIDATE_DETTES_CLIENT = "DettesClient";
export const INVALIDATE_CREANCES_CLIENT = "CreancesClient";
export const INVALIDATE_EXPERT_DOSSIERS = "ExpertDossiers";
export const INVALIDATE_DOSSIER_PARTAGE = "DossierPartage";
export const INVALIDATE_FISCALITE = "Fiscalite";
